'use client'

import { AnimatePresence, motion } from 'framer-motion'
import IconDelete from '~/icons/ic_delete'

import { useLocale } from '~/contexts/LocaleContext'
import { getTranslation } from '~/lib/i18n-utils'
interface DeleteConfirmationProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export default function DeleteConfirmation({
  isOpen,
  onClose,
  onConfirm,
}: DeleteConfirmationProps) {
  const { locale } = useLocale()
  const t = getTranslation(locale)
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[200]">
          <motion.div
            className="fixed inset-0 bg-black/50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          <motion.div className="fixed left-1/2 top-1/2 w-full max-w-[340px] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white p-4">
            <div className="flex flex-col items-center">
              <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[#FDF8F4]">
                <div className="h-8 w-8 text-[#8B5E3C]">
                  <IconDelete />
                </div>
              </div>
              <h3 className="font-lora text-lg font-medium text-secondary-950">
                {t('booking.deleteTitle')}
              </h3>
              <p className="mt-2 text-center font-lexend text-sm font-[350] text-[#666B74]">
                {t('booking.deleteDesc')}
              </p>
              <div className="mt-6 flex w-full gap-3">
                <button
                  onClick={onClose}
                  className="flex-1 rounded-[4px] border border-[#E02424] p-3 text-center font-lexend text-base font-[400] leading-4 text-[#E02424] transition-colors hover:bg-[#E02424]/10"
                >
                  {t('common.skip')}
                </button>
                <button
                  onClick={onConfirm}
                  className="flex-1 rounded-[4px] border border-[#E02424] bg-[#E02424] p-3 text-center font-lexend text-base font-[400] leading-4 text-white transition-colors hover:bg-[#E02424]/80"
                >
                  {t('booking.deleteConfirm')}
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  )
}
